<!-- app/javascript/src/components/triggers/NwsZonePicker.svelte -->
<script lang="ts">
  interface ZoneEntry { code: string; name: string; county: string; }
  interface Catalog { [stateCode: string]: { name: string; zones: ZoneEntry[] }; }

  interface Props {
    selectedZones: string[];
    onChange: (zones: string[]) => void;
  }
  let { selectedZones, onChange }: Props = $props();

  let catalog = $state<Catalog | null>(null);
  let selectedState = $state<string | null>(null);
  let loading = $state(false);
  let error = $state<string | null>(null);

  async function load() {
    if (catalog || loading) return;
    loading = true;
    try {
      const cached = sessionStorage.getItem('nws-zones');
      if (cached) {
        catalog = JSON.parse(cached);
      } else {
        const r = await fetch('/data/nws-zones.json');
        if (!r.ok) throw new Error('failed to load zone catalog');
        catalog = await r.json();
        sessionStorage.setItem('nws-zones', JSON.stringify(catalog));
      }
    } catch (e) {
      error = (e as Error).message;
    } finally {
      loading = false;
    }
  }

  function toggle(code: string) {
    const next = selectedZones.includes(code)
      ? selectedZones.filter(c => c !== code)
      : [...selectedZones, code];
    onChange(next);
  }

  load();
</script>

{#if loading}
  <p>Loading zone catalog…</p>
{:else if error}
  <p class="error">Couldn't load the zone catalog: {error}</p>
{:else if catalog}
  <label for="state-select">State:</label>
  <select id="state-select" bind:value={selectedState}>
    <option value={null}>Choose a state…</option>
    {#each Object.entries(catalog).sort(([a], [b]) => a.localeCompare(b)) as [code, info]}
      <option value={code}>{info.name}</option>
    {/each}
  </select>

  {#if selectedState && catalog[selectedState]}
    <fieldset class="zones">
      <legend>Zones in {catalog[selectedState].name}</legend>
      {#each catalog[selectedState].zones as zone}
        <label>
          <input
            type="checkbox"
            checked={selectedZones.includes(zone.code)}
            onchange={() => toggle(zone.code)}
          />
          <span>{zone.name} <code>{zone.code}</code></span>
        </label>
      {/each}
    </fieldset>
  {/if}

  {#if selectedZones.length > 0}
    <p class="summary">
      Selected: <code>{selectedZones.join(', ')}</code>
      <button type="button" onclick={() => onChange([])}>Clear all</button>
    </p>
  {/if}
{/if}

<style>
  .zones { max-height: 300px; overflow: auto; border: 1px solid #ddd; padding: .5rem; margin-top: .5rem; }
  .zones label { display: block; padding: .25rem; }
  .summary { margin-top: 1rem; }
  .error { color: #b04040; }
</style>
